import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { employee } from './shared/models/employee.model'
import { EmployeeService } from './shared/services/employee.service';
import { ModalDismissReasons, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from 'src/app/shared/adapters/datepicker-adapter';
import { baseSearchModel } from "src/app/shared/models/baseSearchModel";
import { AddEmployeeComponent } from '../employee/add-edit-employee/add-employee.component';
@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class EmployeeComponent implements OnInit {
  employeeSearchCriteria: employee;
  employeeList: any;
  employees: string;
  pageNo: number = 1;
  pageSize: number = 10;
  getEmployeeData: any;
  updateEmployeeData: any;
  InsertDate: NgbDateStruct;
  collectionSize: number;
  sort_employeeList: any;
  contractListingData_content: any;
  constructor(private _modalSvc: NgbModal, public _employeeSvc: EmployeeService) { }

  ngOnInit() {
    this.resetForm();
    // this._employeeSvc.getBlankEmployee().subscribe(response => {
    //   if (response) {
    //     this.employees = response;
    //   }
    // });
    this.employeeSearch(this.pageNo);

  }
  employeeSearch(PageNo: number) {
    this.contractListingData_content = [];
    this.sort_employeeList = [];
    //this.resetForm(); 
    this.employeeSearchCriteria.PageNo = PageNo;
    this._employeeSvc.searchEmployees(this.employeeSearchCriteria).subscribe(employees => {
      // this.employeeList = employees;
      this.collectionSize = employees?.Employees?.length;
      console.log(employees);

      Object.values(employees?.Employees).forEach((element: any) => {
        this.sort_employeeList.push(element);

      });
      this.employeeList = this.sort_employeeList.slice((this.employeeSearchCriteria.PageNo - 1) * this.pageSize, (this.employeeSearchCriteria.PageNo - 1) * this.pageSize + this.pageSize);
      //console.log(this.employeeList)
    });

  }
  clear() {

    this.resetForm();
    this.employeeList = null;

  }

  resetForm() {

    let date = new Date();
    this.InsertDate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() },

      this.employeeSearchCriteria = {
        FirstName: "",
        LastName: "",
        Email: "",
        UserType: "Admin",
        DateFrom: "",
        DateTo: "",
        PageNo: 1,
        PageSize: 10,
      };

  }

  getEmployeeUpdate(ID) {
    debugger;
    if (ID) {
      this._employeeSvc.getEmployee(ID).subscribe(response => {
        if (response) {
          this.employees = response;
          const modalRef = this._modalSvc.open(AddEmployeeComponent);
          modalRef.componentInstance.updateEmployeeData = response;
          modalRef.result.then((result) => {
            if (result === 'success') {
              this.employeeSearch(this.employeeSearchCriteria.PageNo);
            }
          });
        }
      });
    }

  }
  AddEmployee() {
    const modalRef = this._modalSvc.open(AddEmployeeComponent);
    modalRef.result.then((result) => {
      if (result === 'success') {
        this.employeeSearch(1);
      }
    });
  }




}
